import { BalanceIcon } from "./icons/balance-icon";
import { CoinIcon } from "./icons/coin-icon";
import { ComputingIcon } from "./icons/computing-icon";
import { EnvelopeIcon } from "./icons/envelope-icon";
import { HeadphonesIcon } from "./icons/headphones-icon";
import { MegaphoneIcon } from "./icons/megaphone-icon";
import { PersonalCardIcon } from "./icons/personal-card-icon";
import { SMSEditIcon } from "./icons/sms-edit-icon";
import { SMSNotificationIcon } from "./icons/sms-notification-icon";
import { SMSSearchIcon } from "./icons/sms-search-icon";
import { SMSStarIcon } from "./icons/sms-star-icon";
import { SMSTrackingIcon } from "./icons/sms-tracking-icon";
import { SuitcaseIcon } from "./icons/suitcase-icon";
import { UserGroupIcon } from "./icons/usergroup-icon";
import { TrendingUpIcon } from "./icons/trending-up-icon";
import { UserIcon } from "./icons/user-group-icon";
import { UserSquareIcon } from "./icons/user-square-icon";

export const EMAIL_TEMPLATE_ICON_BY_VALUE = {
  message: EnvelopeIcon,
  work: SuitcaseIcon,
  multimedia: HeadphonesIcon,
  personal_card: PersonalCardIcon,
  user: UserGroupIcon,
  sms_notification: SMSNotificationIcon,
  trend_up: TrendingUpIcon,
  coin: CoinIcon,
  user_square: UserSquareIcon,
  profile: UserIcon,
  sms_star: SMSStarIcon,
  sms_tracking: SMSTrackingIcon,
  sms_search: SMSSearchIcon,
  sms_edit: SMSEditIcon,
  balance: BalanceIcon,
  megaphone: MegaphoneIcon,
  computing: ComputingIcon,
};

export const omitColors = [
  "#A286B9",
  "#FF7B01",
];

/** Stricter than the shared isLight default (128) so email text stays light on medium brand colors. */
export const EMAIL_LIGHT_THRESHOLD = 180;

/** Contact phone icon values mapped to the icons ContactDetails renders. */
export const PHONE_TYPE_BY_ICON = {
  mobile: "mobile-phone",
  home: "home",
  work: "work",
  fax: "fax",
  other: "other",
};
